export default {
  '401': 'Authentication failed',
  '403': 'Currently No Permissions',
  '404': 'The access resource does not exist',
  'default': 'Unknown system error'
}
